(function () {
'use strict';

angular.module('hyresgastApp').controller('ImportRentlistCtrl', ImportRentlistCtrl);

function ImportRentlistCtrl(
  $scope, $uibModalInstance, $timeout,
  Negotiation, ErrorHandler, HyUtils,
  negotiation, amend
) {
  var vm = this;
  vm.negotiation = negotiation;
  vm.save = save;
  vm.showSaveButton = true;
  vm.showAdditionalInfoPane = false;
  vm.cancel = cancel;
  vm.showPage = 'Start';
  vm.goToNextPage = goToNextPage;
  vm.toggleAdditionalInfoPane = toggleAdditionalInfoPane;
  vm.onPending = onPending;
  vm.getColumnTitle = title => title instanceof Array ? title[0] : title.split(',')[0].trim();
  vm.status = {
    phase: 'read excel file',
    total: 0,
    errors: 0,
    warnings: 0,
    progress: 0,
    showProgress: false,
  };

  //if the list is uploaded take the summary of the validation response and show in the summary page.
  $scope.$watch('vm.validationResponse', function(validationResponse) {
    if (validationResponse) {
      vm.status = validationResponse;
      vm.validationExcelId = validationResponse.blobId;
      if (vm.validationResponse.status === 'ok') {
        vm.status.phase = 'Success';
        vm.status.comment = '';
        vm.inputRentListBlobId = vm.negotiation.rentListBlobId;

        vm.apartmentsSummary = {};
        vm.apartmentsSummary.apartments = validationResponse.summary.numApartments;
        vm.apartmentsSummary.municipalities = validationResponse.summary.numMunicipalities;
        vm.apartmentsSummary.properties = validationResponse.summary.numProperties;
      } else if (vm.validationResponse.status === 'error') {
        $uibModalInstance.dismiss();
        HyUtils.showDefaultModal('ErrorModalCtrl', 'resources/validation/errors.html', {
          validationResponse, realEstateChoiceMethod: null,
        });
      }
    }
  });

  ////////////

  function goToNextPage(page) {
    vm.showPage = page;
  }

  function save() {
    vm.saving = true;
    Negotiation.importRentList({
      id: vm.negotiation.id,
      rentListBlobId: vm.negotiation.rentListBlobId,
      amend,
    }).$promise.then(() => { $uibModalInstance.close('Hyreslistan har laddats upp till förhandlingen.'); })
      .catch(new ErrorHandler('Misslyckades att ladda upp hyreslistan.'))
      .finally(() => { vm.saving = false; });
  }

  function cancel() {
    vm.negotiation.rentListBlobId = null;
    $uibModalInstance.dismiss();
  }

  function toggleAdditionalInfoPane() {
    vm.showAdditionalInfoPane = !vm.showAdditionalInfoPane;
  }

  function onPending(validation) {
    if (vm.status.showProgress && vm.status.progress > 0 && vm.status.phase !== validation.phase) {
      vm.status.progress = 100;
      $timeout(() => {
        vm.status.progress = 0;
        vm.status.phase = validation.phase;
        vm.status.comment = validation.comment;
        $timeout(() => vm.status = validation, 500);
      }, 300);

    } else {
      vm.status = validation;
    }
  }
}

})();